/*  {
    name: "",
    position: "",
    comment: "",
  },

*/
export const testimonialsInfo = [];
